import React from 'react'
import { Button, Modal } from "react-bootstrap";

export const ThankYouModal = (props) => {
    return (
        <Modal
            {...props}
            centered
            size="xl" // Change the size as per your requirement
            backdrop="static"
        >
            <Modal.Header closeButton className="border-bottom-0 position-absolute right-0 z-1">
                {/* <Modal.Title>Modal Title</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="text-center p-5">
                <h3 className="my-3 text-lg font-semibold text-blue">
                    {props.msgObj.afterSubmissionText}
                </h3>
                {/* <p className="text-grey-700">
                    Want to know about Upcoming events? Click the button below
                </p>
                <Button variant="primary" onClick={props.onHide}>
                    Check upcoming events
                </Button> */}
            </Modal.Body>
        </Modal>
    )
}
